import dice from "./dice";
import slice from "./slice";

export default function(parent, x0, y0, x1, y1) {
  (parent.depth & 1 ? slice : dice)(parent, x0, y0, x1, y1);
}



//////////////////
// WEBPACK FOOTER
// /Users/sharvil/Desktop/fall17/adaptive/assign1/~/d3-hierarchy/src/treemap/sliceDice.js
// module id = ../../../../d3-hierarchy/src/treemap/sliceDice.js
// module chunks = 3